import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { DIALOG_SIZES } from 'src/modules/shared/constants/common';
import { DeleteOwnerPopupComponent } from './delete-owner.component';

@Directive({
  selector: '[rsDeleteOwner]'
})
export class DeleteOwnerPopupDirective {

  @Output() accepted = new EventEmitter<void>();

  @Input() view: boolean;

  constructor(
    private dialog: MatDialog
  ) {}

  @HostListener('click', ['$event'])
  openDeleteOwnerPopup(event: MouseEvent): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(DeleteOwnerPopupComponent, {
      width: DIALOG_SIZES.MIDDLE,
      data: this.view
    });

    dialogRef.afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.accepted.emit();
        }
      });
  }

}
